import { create } from "zustand";
import { persist } from "zustand/middleware";

import { createLegacyStorage, syncAcrossTabs } from "./legacyStorage";

const KEYS = ["currentCallData", "incomingCallInfo"];

/**
 * Active dialer call state, shared between the PowerDialer window and the
 * PowerDialerMonitor window through the legacy "currentCallData" key.
 *
 * "incomingCallInfo" hands an accepted inbound call to the dialer window this
 * page is about to open. It goes through storage rather than postMessage so
 * the dialer cannot miss it by mounting after the message was posted.
 */
const useDialerStore = create(
  persist(
    (set, get) => ({
      currentCallData: undefined,
      setCurrentCallData: currentCallData => set({ currentCallData }),
      clearCurrentCallData: () => set({ currentCallData: undefined }),
      incomingCallInfo: undefined,
      setIncomingCallInfo: incomingCallInfo => set({ incomingCallInfo }),
      /**
       * Take the accepted inbound call left for this dial session, once.
       *
       * Returns undefined for any other session, so a record left over from an
       * earlier inbound call cannot make an outbound dialer behave as an
       * inbound one. The session id is compared as a string because the route
       * carries it as text and the API as a number.
       */
      claimIncomingCallInfo: dialSessionId => {
        const { incomingCallInfo } = get();
        if (
          !incomingCallInfo ||
          String(incomingCallInfo.dialSessionId) !== String(dialSessionId)
        ) {
          return undefined;
        }
        set({ incomingCallInfo: undefined });
        return incomingCallInfo;
      },
    }),
    { name: "dialer", storage: createLegacyStorage(KEYS) }
  )
);

syncAcrossTabs(useDialerStore, KEYS);

export default useDialerStore;
